import React from 'react';
import { mergeClassNames } from '@core/shared-utils';

export function LengthIndicator({ maxLenght, currentTextContent, shouldValidate, touched }) {
    if (!maxLenght) {
        return <small className="form-input-length-placeholder">&#8288;</small>;
    }

    const minLength = shouldValidate && shouldValidate.minLength && shouldValidate.minLength.value;
    const tooShort = minLength && currentTextContent.length < minLength;
    const tooLong = currentTextContent.length > maxLenght;
    const lengthIndicatorClasses = mergeClassNames(
        'form-text',
        'form-input-length',
        tooLong || (tooShort && touched) ? 'text-danger' : ''
    );

    return (
        <>
            <small className={lengthIndicatorClasses} aria-hidden={true}>
                {currentTextContent.length} / {maxLenght} Zeichen
            </small>
            <small className="visually-hidden">
                {`${currentTextContent.length} von ${maxLenght} Zeichen verwendet.`}
            </small>
            <small className="visually-hidden" aria-live="assertive" role="status">
                {`Noch ${maxLenght - currentTextContent.length} Zeichen übrig`}
            </small>
        </>
    );
}
